import { Container, SectionTitle, UseCases } from '@sloyd/ui';
import { Wrapper } from './ContentUseCases.style';

export type ContentUseCasesProps = {};

export function ContentUseCases(_props: ContentUseCasesProps) {
  return (
    <Wrapper className='ContentUseCases-wrapper' data-testid='ContentUseCases-wrapper'>
      <SectionTitle gradient={{ from: '#3a6186', to: '#89253e' }} title='💡 Use Cases'>
        Discover inspiring <strong>use cases</strong> for Sloyd in various fields.
      </SectionTitle>
      <Container>
        <UseCases />
      </Container>
    </Wrapper>
  );
}

export default ContentUseCases;
